<template>
    <nav class="breadcrumbs">
        <ul :class="`breadcrumbs__container container ${containerClasses}`" :style="{ maxWidth: containerWidth }">
            <template v-if="!isPreloader">
                <li
                    class="breadcrumbs__container__group"
                    :class="{ active: isActive(index) }"
                    v-for="(breadcrumb, index) in combinedElements"
                    :key="index"
                >
                    <span v-if="index !== 0">/</span>
                    <NuxtLink :to="localePath(index === 0 ? `${breadcrumb.route}` : `/${breadcrumb.route}`)">{{
                        breadcrumb.title
                    }}</NuxtLink>
                </li>
            </template>
        </ul>
    </nav>
</template>

<script>
import { BreadcrumbsItem } from './types';
import VueTypes, { nullable } from 'vue-types';

export default {
    name: 'Breadcrumbs',
    props: {
        elements: VueTypes.arrayOf(BreadcrumbsItem).isRequired,
        isPreloader: VueTypes.bool.def(false),
        containerClasses: VueTypes.string.def(''),
        containerWidth: VueTypes.oneOfType([String, nullable]).def(null)
    },
    computed: {
        combinedElements() {
            return [{ title: this.$t('breadcrumbsItemHome'), route: '/' }, ...this.elements];
        }
    },
    methods: {
        isActive(index) {
            if (index === this.combinedElements.length - 1) return true;
            return false;
        }
    }
};
</script>

<style lang="scss">
@import './styles.scss';
</style>
